import React from 'react';
import parse from 'html-react-parser';

export default function Item({
  id,
  title,
  link,
  types,
  industries,
  featuredImage,
}) {
  const classNames = [
    'wp-block-post',
    `post-${id}`,
    'work',
    'type-work',
    'status-publish',
    featuredImage && 'has-post-thumbnail',
    'hentry',
    ...types.map((type) => `project_types-${type.slug}`),
    ...industries.map((type) => `industries-${type.slug}`),
  ]
    .filter(Boolean)
    .join(' ');

  const image =
    featuredImage?.media_details.sizes.large ||
    featuredImage?.media_details.sizes.medium_large;

  return (
    <li className={classNames}>
      <figure className="wp-block-post-featured-image">
        <a href={link}>
          <img
            loading="lazy"
            width={image?.width}
            height={image?.height}
            src={image?.source_url}
            className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
            alt={featuredImage?.alt_text}
          />
        </a>
      </figure>

      <h2 className="wp-block-post-title has-h-5-font-size">
        {title && parse(title)}
      </h2>
    </li>
  );
}
